
















































import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import AgroIcons from "@/components/agroIcons/AgroIcons.vue";
import { BulkUploadDTO } from "@/api/bulk/types";
import * as notificationService from "@/services/notification/index";
import i18n from "@/i18n";
import { csvToObj } from "csv-to-js-parser";
import { plainToClass } from "class-transformer";
import *  as geomUtils from '@/helpers/geojson';
import *  as geometryUtils from '@/helpers/geometry';

@Component({
  name: "FileUploadFarm",
  components: {
    AgroIcons,
  },
})
export default class FileUploadFarm extends Vue {
  @Prop({ type: Boolean, default: false }) private isVisible!: boolean;
  private file: File | null = null;
  private isLoading: boolean | null = null;

  private fieldsDescription: any = {
    farm_name: { type: "string", group: 1 },
    owner_name: { type: "string", group: 1},
    owner_id: { type: "string", group: 1 },
    lat: { type: "number", group: 1 },
    lng: { type: "number", group: 1 },
    car_code: { type: "string", group: 1 },
    incra_allotment: { type: "string", group: 1 },
    analitica: { type: "boolean", group: 1 },
    sentinela: { type: "boolean", group: 1 },
    crop_type_1: { type: "string", group: 1 },
    crop_type_2: { type: "string", group: 1 },
    geom: { type: "string", group: 1 },
  };

  private changeFile(event: any) {
    this.file = (event as DragEvent).dataTransfer!.files[0];
  }

  private closeFileUpload() {
    this.file = null;
    this.$emit("toggle", event);
  }

  private changedFile() {
    if (this.$refs.geoUpload !== null) {
      this.file = (this.$refs.geoUpload as HTMLInputElement).files![0];
    }
  }

  private sendGeoFile() {
    this.isLoading = true;

    if (this.file == null) return;
    const reader = new FileReader();
    reader.onload = (e) => {
      const fileloaded = e.target?.result ?? null;
      if (fileloaded === null) return;
      this.convertFileLines(fileloaded as string);
      this.isLoading = false;
    };
    reader.readAsText(this.file);

    this.$emit("toggle", event);
  }

  private convertFileLines(file: string) {

    try {
      const fields = file.split('\n')[0].split(';');
      const presentHeaders = Object.fromEntries(fields
        .map(x => x.trim().toLowerCase())
        .filter((it: string) => this.fieldsDescription[it] != undefined)
        .map(x => [x, this.fieldsDescription[x]])
      );

      let formatedData:[] = csvToObj(file, ";", presentHeaders);

      const data = plainToClass(BulkUploadDTO, formatedData)
        .map(it => {
          if (it.geom) {
            it.geom = JSON.parse(it.geom + "");
          }
          return it;
        });
        
      this.$emit("linesConverted", data);
    } catch(err) {
      console.log(err);
      this.$emit("linesConvertedError", true);
    }

    this.file = null;
  }
}
